import { useEffect, useState } from "react";import "./JobList.css";
import JobFilters from "./JobFilters";
import JobCard from "./JobCard";
import JobDetailsModal from "./JobDetailsModal";
const API = "http://localhost:3001/jobs";



function JobList() {
const [selectedJob, setSelectedJob] = useState(null);
const [jobs, setJobs] = useState([]);
useEffect(() => {
  fetchJobs();
}, []);

const fetchJobs = async () => {
  try {
    const res = await fetch(API);
    const data = await res.json();

    setJobs(Array.isArray(data) ? data : []);
  } catch (err) {
    console.log(err);
    setJobs([]);
  }
};
const [search, setSearch] = useState("");
const [company, setCompany] = useState("");
const [location, setLocation] = useState("");
const [type, setType] = useState("");
console.log("Jobs:", jobs);
const filteredJobs = jobs.filter((job) => {
  return (
    job.title.toLowerCase().includes(search.toLowerCase()) &&
    (company === "" || job.company === company) &&
    (location === "" || job.location === location) &&
    (type === "" || job.type === type)
  );
});
  return (
    
    <section className="job-list">
<JobFilters
  search={search}
  setSearch={setSearch}
  company={company}
  setCompany={setCompany}
  location={location}
  setLocation={setLocation}
  type={type}
  setType={setType}
/>
      {/* Header */}

      <div className="job-list-header">

        <div>

          <span className="job-list-badge">
            💼 Career Opportunities
          </span>

          <h2>Latest Placement Openings</h2>

          <p>
            Discover exciting career opportunities from our trusted hiring
            partners. Apply today and begin your professional journey.
          </p>

        </div>

        <div className="job-total-card">

      <h3>{filteredJobs.length}</h3>
          <span>Active Jobs</span>

        </div>

      </div>

      {/* Jobs */}

   {filteredJobs.length > 0 ? (

<div className="job-grid">
 {filteredJobs.map((job) => (
    <JobCard
      key={job.id}
      job={job}
      onView={setSelectedJob}
    />
  ))}
</div>

      ) : (

        <div className="job-empty">

          <h3>No Jobs Available</h3>

          <p>
            There are currently no active placement opportunities.
            Please check back later.
          </p>

        </div>

      )}

      {/* Modal */}

      {selectedJob && (
        <JobDetailsModal
          job={selectedJob}
          onClose={() => setSelectedJob(null)}
        />
      )}

    </section>
  );
}

export default JobList;